module.exports = __webpack_public_path__ + "static/img/A8.e03a732e.jpg";